module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/guide2-24bc9f9b66627621283a9fe99258203f.png";